import { ApolloError, useMutation } from '@apollo/client';
import {
    AllFinancialEntitiesDocument,
    AtomicConsentInput,
    AtomicStatusDocument,
    CurrentUserProfileDocument,
    StartIndividualAccountOpeningDocument,
} from '../../graphql/generated';

export const useStartIndividualAccountOpening = ({
    atomicConsentInput,
    onComplete,
    onError,
}: {
    atomicConsentInput: AtomicConsentInput;
    onComplete: VoidFunction;
    onError: (e: ApolloError) => void;
}) => {
    const [mutation, { loading }] = useMutation(
        StartIndividualAccountOpeningDocument,
        {
            refetchQueries: [
                { query: AtomicStatusDocument },
                { query: CurrentUserProfileDocument },
                { query: AllFinancialEntitiesDocument },
            ],
            awaitRefetchQueries: true,
        }
    );
    const startIndividualAccountOpening = () => {
        mutation({
            variables: {
                ...atomicConsentInput,
            },
            onCompleted: onComplete,
            onError,
        });
    };

    return { startIndividualAccountOpening, isLoading: loading };
};
